<template>
	<div id="index" class="page">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div class="host-body">
				<Navbar @logout="logout" :navbarType='navbarType' :buildingName='buildingName' />
				<div class="body-box">
					<div class="content-box">
						<div class="colbox" style="margin-left: 0.3rem;">
							<div>
								<topLeft :topLeftData='topLeftData' />
							</div>
							<div class="mt-3" v-if='topLeftData'>
								<centerLeft :buildingShow='buildingShow' />
							</div>
							<div class="mt-3">
								<bottomLeft />
							</div>
						</div>
						<div class="colbox" style="margin-left: 0.4rem;">
							<div>
								<topCenter :topData="topData" :geoCoordMap="geoCoordMap" />
							</div>
							<div class="mt-3">
								<bottomCenter :bottomCenterData='bottomCenterData' />
							</div>
						</div>
						<div class="colbox" style="margin-left: 0.4rem;">
							<div>
								<topRight />
							</div>
							<div class="mt-3">
								<centerRight :centerRightData='centerRightData' />
							</div>
							<div class="mt-3">
								<bottomRight />
							</div>
						</div>
					</div>
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
	import Navbar from "../layout/Navbar";
	import topLeft from "./index/topLeft";
	import centerLeft from "./index/centerLeft";
	import bottomLeft from "./index/bottomLeft";
	import topCenter from "./index/topCenter";
	import bottomCenter from "./index/bottomCenter";
	import topRight from "./index/topRight";
	import centerRight from "./index/centerRight";
	import bottomRight from "./index/bottomRight";
	import Cookies from 'js-cookie';
	import store from '../store/index.js';

	export default {
		data() {
			return {
				loading: true,
				navbarType: false,
				topLeftData: {
					building_num: '',
					cooling_area: '',
				},
				bottomCenterData: {
					device_count: '',
					online: '',
					running: '',
				},
				centerRightData: {},
				buildingShow: [],
				buildingSelect: [],
				buildingName: '杭州能工',
				building: '',
				topData: [],
				geoCoordMap: {}
			};
		},
		components: {
			Navbar,
			topLeft,
			centerLeft,
			bottomLeft,
			topCenter,
			bottomCenter,
			topRight,
			centerRight,
			bottomRight,
		},
		created(){
			// console.log(this.$store.state.count)
			this.getBuilding();
			this.projectScale();
			this.totalOperation();
		},
		mounted() {
			this.cancelLoading();
			// 定时刷新当前时间
			// this.currentTime();
		},
		methods: {
			async projectScale() {
				await this.$axios.get("/api/buildings/projectScale").then(res => {
					this.topLeftData.building_num = res.data.data.building_num;
					this.topLeftData.cooling_area = (res.data.data.cooling_area / 10000).toFixed();
					this.bottomCenterData.device_count = res.data.data.device_count;
				})
			},
			async totalOperation() {
				await this.$axios.get("/api/buildings/totalOperation").then(res => {
					this.bottomCenterData.online = res.data.data.online;
					this.bottomCenterData.running = res.data.data.running;
					this.centerRightData = res.data.data.operating_load_ratio;
				})
			},
			async getBuilding() {
				let sortNum = function(a, b){
					return b[1]-a[1];
				}
				await this.$axios.get("/api/buildings").then(res => {
					let buildingSelect = []
					let buildingShow = []
					for (let item of res.data.data) {
						buildingSelect.push({
							label: item.abbreviation,
							value: String(item.id)
						})
						buildingShow.push([
							item.abbreviation,
							item.coolingarea
						])
					}
					buildingShow.sort(sortNum);
					for(var i=0;i<buildingShow.length;i++){
						buildingShow[i].unshift(i+1)
					}
					this.buildingShow = buildingShow.slice(0,49)
					this.buildingSelect = buildingSelect
					if(Cookies.get('building')){
						this.building = Cookies.get('building')
					}else{
						Cookies.set('building', buildingSelect[0].value)
						Cookies.set('buildingName', buildingSelect[0].label)
						this.building = buildingSelect[0].value
					}
					
					let keyMap = [];
					let data = [];
					res.data.data.forEach(item => {
						//城市和经纬度的数组
						keyMap.push([item.abbreviation, [item.lon, item.lat]]);
						//鼠标划过显示信息的数组
						data.push({
							name: item.abbreviation,
							id: item.id,
							province: item.province,
							value: [item.coolingarea, item.coolingvolume]
						});
					});
					this.topData = data
					this.geoCoordMap = new Map(keyMap); //此处为es6的map 语法，用来处理键值对
				})
			},
			// getTime: function () {
			//   var _this = this;
			//   let yy = new Date().getFullYear();
			//   let mm = new Date().getMonth() + 1;
			//   let dd = new Date().getDate();
			//   let hh = new Date().getHours();
			//   let mf =
			//     new Date().getMinutes() < 10
			//       ? "0" + new Date().getMinutes()
			//       : new Date().getMinutes();
			//   let ss =
			//     new Date().getSeconds() < 10
			//       ? "0" + new Date().getSeconds()
			//       : new Date().getSeconds();
			//   _this.currtime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
			// },
			// currentTime() {
			// 	setInterval(this.getTime, 1000);
			// },
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 1000);
			},
			logout() {
				this.$axios.post("/api/logout").then(res => {
					if (process.env.NODE_ENV === "production") {
					  Cookies.remove('token', { domain: "hzng-iot.com" });
					} else {
					  Cookies.set('token', '', -1)
					}
					this.$router.replace("/login");
				})
			},
		},
	};
</script>

<style lang="scss">
	@import "../assets/scss/index.scss";
</style>
